import Route from '@ember/routing/route';

class AdminCompaniesRoute extends Route {
  get queryParams() {
    return {
      idOrSlug: { replace: true },
      name: { replace: true },
      tier: { replace: true },
      onInvoice: { replace: true },
      changeUser: { replace: true },
      page: { replace: true },
    };
  }

  /** @inheritDoc */
  model({ idOrSlug, name, tier, onInvoice, page }) {
    const loadCompaniesOnInitialization = (
      idOrSlug !== null
      || name !== null
      || tier !== null
      || onInvoice !== null
      || page !== 1
    );

    return {
      companies: null,
      loadCompaniesOnInitialization,
    };
  }

  /** @inheritDoc */
  setupController(controller, model) {
    super.setupController(...arguments);

    if (model.loadCompaniesOnInitialization) {
      controller.loadCompanies.perform();
    }
    if (controller.changeUser) {
      controller.loadUser.perform(controller.changeUser);
    }
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadCompanies.cancelAll();
      controller.loadUser.cancelAll();
      controller.set('user', null);
    }
  }
}

export default AdminCompaniesRoute;
